import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { FaHome, FaSignOutAlt } from 'react-icons/fa';
import logo from '../ap-logo-4.png';
import './Navbar.css';

const Navbar = ({ title = "Akshaya Patra UK - Order Management" }) => {
  const navigate = useNavigate();

  const handleSignOut = () => {
    const isConfirmed = window.confirm('Are you sure you want to sign out?');
    if (isConfirmed) {
      signOut(getAuth())
        .catch(err => console.error('Error signing out', err))
        .finally(() => navigate('/', { replace: true }));
    }
  };

  const navigateToHome = () => {
    navigate('/home');
  };

  return (
    <nav className="professional-navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <img src={logo} alt="Akshaya Patra Logo" className="navbar-logo" />
          <h1 className="navbar-title">{title}</h1>
        </div>
        <div className="navbar-right">
          <button className="navbar-btn navbar-home-btn" onClick={navigateToHome}>
            <FaHome className="navbar-icon" />
            <span>Home</span>
          </button>
          <button className="navbar-btn navbar-signout-btn" onClick={handleSignOut}>
            <FaSignOutAlt className="navbar-icon" />
            <span>Sign Out</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
